import { render, staticRenderFns } from "./ClearMontage.vue?vue&type=template&id=3e95dd3c&scoped=true"
import script from "./ClearMontage.vue?vue&type=script&lang=ts"
export * from "./ClearMontage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95dd3c",
  null
  
)

export default component.exports